<template>
    <div class="printManagementDialog">
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="800px">
            <div class="dialogContent">
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
                    <el-form-item label="收货人" prop="receiverName">
                        <el-input v-model="form.receiverName" placeholder="请填写收货人名字"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="mobile">
                        <el-input v-model="form.mobile" placeholder="请填写手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="所在地区" prop="storeCity">
                        <el-cascader
                            clearable
                            v-model="storeCity"
                            :options="provinceOptions"
                            clearable style="width: 100%;" placeholder="省/市/区"></el-cascader>
                    </el-form-item>
                    <el-form-item label="详细地址" prop="areaInfo">
                        <el-input v-model="form.areaInfo" placeholder="请填写详细地址"></el-input>
                    </el-form-item>
                    <el-form-item label="设为默认地址" prop="defaultVal">
                        <el-radio-group v-model="form.defaultVal">
                            <el-radio v-for="(item,index) in processTypeList" :key="index" :label="item.value">
                                {{ item.name }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item class="submitButtonClass">
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getAddressDetail,saveAddressInfo,editAddressInfo } from '../../utils/interface';
    export default {
        name: "materialManagementDialog",
        data() {
            return {
                dialogVisible: false,
                title: '',
                provinceOptions: this.provinceData,
                storeCity:'',
                form: {
                    areaInfo: '',
                    city: '',
                    defaultVal: 0,
                    district: '',
                    mobile: '',
                    province: '',
                    receiverName: '',
                },
                processTypeList: [
                    {
                        value:0,
                        name: '否'
                    },
                    {
                        value:1,
                        name: '是'
                    }
                ],
                rules: {
                    areaInfo: [
                        {required: true, message: '请输入收货人详细地址', trigger: 'blur'}
                    ],
                    defaultVal: [
                        {required: true, message: '请选择是否为默认地址', trigger: 'change'}
                    ],
                    mobile: [
                        {required: true, validator: this.validatorPhone,trigger: 'blur'}
                    ],
                    receiverName: [
                        {required: true, message: '请输入收货人姓名',trigger: 'blur'}
                    ]
                },
            }
        },
        methods: {
            // 电话号码校验
            validatorPhone(rule, value, callback) {
                if (value === '') {
                    callback(new Error('请输入联系人电话'))
                } else if (!/^1\d{10}$/.test(value)) {
                    callback(new Error('请输入正确的电话号码'))
                } else {
                    callback()
                }
            },
            init(type,uuid) {
                this.dialogVisible = true;
                if(this.$refs.ruleForm){
                    this.$refs.ruleForm.resetFields()
                }
                this.storeCity = "";
                this.form = {};
                if (type === 'add') {
                    this.title = '新增';
                } else {
                    this.title = '编辑';
                    getAddressDetail({uuid:uuid}).then((res)=>{
                        this.form = res;
                        let arr = new Array();
                        if(res.province!=''&&res.province!=res.city){
                            arr.push(res.province.replace('省',''));
                        }else if(res.province!=''&&res.province==res.city){
                            arr.push(res.province.replace('市',''));
                        }
                        if(res.city!=''&&res.province!=res.city){
                            arr.push(res.city.replace('市',''));
                        }
                        if(res.district!=''){
                            arr.push(res.district);
                        }
                        this.storeCity = arr;
                    });
                }
            },
            submit(){
                if(this.storeCity != null && this.storeCity.length == 3){
                    this.form.province = this.storeCity[0]+"省";
                    this.form.city = this.storeCity[1]+"市";
                    this.form.district = this.storeCity[2];
                } else if(this.storeCity != null && this.storeCity.length == 2){
                    this.form.province = this.storeCity[0]+"市";
                    this.form.city = this.storeCity[0]+"市";
                    this.form.district = this.storeCity[1];
                }
                console.log(this.form);
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        if(this.form.uuid != null){
                            editAddressInfo(this.form).then((res)=>{
                                this.$message.success('修改成功！');
                                this.dialogVisible = false;
                                this.$parent.getAddressList();
                            });
                        }else{
                            saveAddressInfo(this.form).then((res)=>{
                                this.$message.success('保存成功！');
                                this.dialogVisible = false;
                                this.$parent.getAddressList();
                            });
                        }
                    } else {
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped lang="less">
    .dialogContent {
        padding: 0 5%;
        /deep/.el-upload-list--picture-card .el-upload-list__item{
            width: 80px;
            height: 80px;
        }
        /deep/.el-upload--picture-card{
            width: 80px;
            height: 80px;
            line-height: 80px;
        }
        /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail{
            width: 80px;
            height: 80px;
        }
        .thumbnailClass{
            width: 80px;
            height: 80px;
            margin-right: 20px;
            .avatar{
                width: 80px;
                height: 80px;
                border: 1px dashed #ddd;
                border-radius: 4px;
                line-height: 80px;
                font-size: 24px;
            }
        }
        .endPeriodClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
            }
        }
        .submitButtonClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
                text-align: center;
                button{
                    padding: 0;
                    width: 120px;
                    height: 35px;
                    line-height: 35px;
                    border-radius: 6px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/tradShippAddressDialog.vue